import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "sceneConstructorMenuItemIcon" }
const _hoisted_2 = { class: "sceneConstructorMenuItemIcon__in" }
const _hoisted_3 = {
  key: 0,
  class: "sceneConstructorMenuItemIcon__check"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 512 512" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m176 464l-176-176l80-83l112 107l248-248l72 72z" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "sceneConstructorMenuItemIcon__wrap",
      style: _normalizeStyle({
        'background-color': _ctx.backgroundColor,
        'background-image': _ctx.backgroundImage ? 'url(' + _ctx.backgroundImage + ')' : ''
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default"),
        (_ctx.checked)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}